import VuiTypography from "components/VuiTypography";

export const MyTypography = (props) => {
  const { ...rest } = props;

  return <VuiTypography {...rest} />;
};
